export class constants {
    public static readonly CORTEVA_EMAIL_DOMAIN_NAME: string = "corteva.com";
    public static readonly REQUESTER_ROLE: string = "requester";
}